export const validation =  {
  maxTitleChar: 120,
  maxParagraphChar: 1500,
  maxBlockTitle: 80,
  maxBlockParagraph: 210,
  blocks: {
    min: 1,
    max: 3
  }
}